import { memo } from 'react';

import { usePublicBoardAssetShare } from '~/components/AssetModalV2/Header/PublicBoardAssetComponents/usePublicBoardAssetShare';
import {
  PublicBoardAssetHeader,
  type PublicBoardAssetHeaderProps,
} from '~/components/AssetModalV2/Header/PublicBoardAssetHeader';
import {
  PublicAssetModalDesktopLayout,
  type PublicAssetModalDesktopLayoutProps,
} from '~/components/AssetModalV2/PublicAssetModalDesktopLayout';
import { useURLBoardIdSelector } from '~/hooks/useURLBoardIdSelector';

export type PublicBoardAssetModalDesktopLayoutProps = Pick<PublicBoardAssetHeaderProps, 'onCloseAssetModal'> &
  Pick<PublicAssetModalDesktopLayoutProps, 'onCloseAssetModal'>;

export const PublicBoardAssetModalDesktopLayout = memo(
  ({ onCloseAssetModal }: PublicBoardAssetModalDesktopLayoutProps) => {
    const { sharePublicBoardAsset } = usePublicBoardAssetShare();
    const boardId = useURLBoardIdSelector();

    return (
      <PublicAssetModalDesktopLayout
        header={<PublicBoardAssetHeader onCloseAssetModal={onCloseAssetModal} />}
        onCloseAssetModal={onCloseAssetModal}
        onShare={sharePublicBoardAsset}
        showFullscreenNavigationArrows={!!boardId}
      />
    );
  },
);

PublicBoardAssetModalDesktopLayout.displayName = 'PublicBoardAssetModalDesktopLayout';
